import { render, staticRenderFns } from "./GameSummary.vue?vue&type=template&id=b8030872&scoped=true&"
import script from "./GameSummary.vue?vue&type=script&lang=js&"
export * from "./GameSummary.vue?vue&type=script&lang=js&"
import style0 from "./GameSummary.vue?vue&type=style&index=0&id=b8030872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8030872",
  null
  
)

export default component.exports